import { Wrench } from 'lucide-react'
import { useTranslation } from 'react-i18next'

const Maintenance = () => {
  const { t } = useTranslation()

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-muted p-4">
      <div className="text-center max-w-md">
        <div className="mx-auto w-20 h-20 rounded-full bg-primary/10 flex items-center justify-center mb-6">
          <Wrench className="w-10 h-10 text-primary animate-pulse" />
        </div>
        <h1 className="text-4xl font-bold text-primary">
          {t('maintenance.title', 'Under maintenance')}
        </h1>
        <p className="mt-4 text-muted-foreground">
          {t(
            'maintenance.message',
            "We're performing scheduled maintenance to improve your experience. We'll be back shortly.",
          )}
        </p>
        <p className="mt-6 text-sm text-muted-foreground">
          {t('maintenance.thanks', 'Thank you for your patience.')}
        </p>
      </div>
    </div>
  )
}

export default Maintenance
